import React from 'react'
import { Box, Typography } from '@mui/material'

export default function NoPermission() {
    return (
        <Box height={'80vh'} width={'100%'} textAlign={'center'}>
            <Typography fontSize={40} marginTop={10}>
                <span role='img' aria-label='alert'> &#10060;</span> You don't have necessary permission to access this page. <a href='/'>Home</a>
            </Typography>
        </Box>
    )
}
